export default __webpack_public_path__ + "static/media/高新技术企业证书.bcba686f.png";